<template>
	<v-dialog
		v-model="localShowDialog"
		@click:outside="closeDialog"
		@keydown.esc="closeDialog"
		scrollable
		:width="$vuetify.display.mobile ? '95%' : '500px'"
	>
		<v-card>
			<v-card-title class="dialog-header sgnl-subtitle-medium"
				>Gateway Data Streams
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="closeDialog"
				>
					<Close16 />
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="dialog-body">
				<LoadingCard
					v-if="loadingFiles"
					loadingText="Loading Data Stream"
				/>

				<div v-else>
					<v-list
						v-if="dataFileList && dataFileList.length > 0"
						max-width="500"
						density="compact"
						flat
					>
						<v-list-item
							v-for="(file, i) in dataFileList"
							:key="i"
						>
							<template v-slot:prepend>
								<ReportData16 />
							</template>
							<v-list-item-title>{{ formatFilePath(file.path) }}</v-list-item-title>
							<v-list-item-subtitle>Updated at {{ formatDate(file.updated_at) }}</v-list-item-subtitle>
						</v-list-item>
					</v-list>

					<!-- <v-treeview
						v-if="dataFileList && dataFileList.length>0"
						v-model="fileListBuffer"
						v-model:items="dataFileList"
						v-model:open="openTrees"
						v-model:active="chosenFile"
						item-key="path"
						expand-icon="mdi-chevron-down"
						return-object
						transition
						density="compact"
						class="sgnl-paragraph-s-regular sgnl-mr-8"
						:activatable="selectable"
					>
						<template v-slot:prepend="{ open }">
							<FolderOpen16 v-if="open" />
							<Document16 v-else />
						</template>
					</v-treeview> -->
					<v-alert
						v-else
						class="sgnl-flex sgnl-justify-center sgnl-my-20 sgnl-mx-auto"
						variant="outlined"
						width="80%"
						type="warning"
						density="compact"
						border="start"
					>
						No data streams found...
					</v-alert>
				</div>
			</v-card-text>
			<template v-if="selectable">
				<v-divider />
				<v-card-actions class="dialog-footer">
					<v-btn
						variant="flat"
						color="primary"
						width="150px"
					>
						Set Data Source
					</v-btn>
				</v-card-actions>
			</template>
		</v-card>
	</v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";
import ReportData16 from "@carbon/icons-vue/es/report--data/16";
import { sdk } from "@/js/sdk";
import moment from "moment";
import LoadingCard from "@/components/LoadingCard.vue";
import * as dsUtil from "@/components/DataSources/utilities";
import { monitoringCaptureError } from "@/plugins/monitoring";

export default defineComponent({
	name: "GatewayDataStreamsDialog",
	components: { Close16, ReportData16, LoadingCard },
	props: {
		showDialog: {
			type: Boolean,
			default: false,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		gatewayID: {
			type: String,
			default: "",
		},
	},
	emits: {
		"update:showDialog": (_data) => true,
	},
	data: () => ({
		dataFileList: undefined,
		fileListBuffer: [],
		openTrees: [],
		chosenFile: [],
		loadingFiles: false,
	}),
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
	},
	methods: {
		closeDialog() {
			this.$emit("update:showDialog", false);
		},
		async getGatewayFiles() {
			this.loadingFiles = true;
			try {
				const response = await sdk.things.getFiles(this.gatewayID);
				this.dataFileList = dsUtil.parseGatewayFiles(response.Items);
				this.dataFileList.sort((a, b) => {
					return b.updated_at - a.updated_at;
				});
			} catch (error) {
				monitoringCaptureError(error, "Fetch gateway files list");
			} finally {
				this.loadingFiles = false;
			}
		},
		formatFilePath(path) {
			// Remove the gateway ID from the file path
			return path.split("/").slice(1).join("/");
		},
		formatDate(dtString) {
			if (dtString > 0) {
				return moment.unix(dtString).format("HH:mm:ss on DD MMM YYYY");
			} else {
				return "---";
			}
		},
	},
	mounted() {
		this.getGatewayFiles();
	},
});
</script>
